import React from "react";
import { useQuery } from "react-query";
import { Switch } from "react-router-dom";

import Loader from "../../loader/Loader";
import RouteWithSubRoutes from "app/utils/RouteWithSubRoutes";
import { CLIENT_CONFIG } from "app/api/ApiEndpoints";
import { CLIENT_CONFIG_DETAILS } from "app/context/Types";
import { StoreContext } from "app/context/Store";
import { useGet } from "app/services/http-service";
import Themes from "app/styles/theme/Themes";

export default function AuthLayout(props) {
  const { route } = props;
  const context = React.useContext(StoreContext);
  const themeName = localStorage.getItem("theme");
  const { data: clientConfigData, isSuccess: fetchedClientConfigData } =
    useQuery("fetchedClientConfigData", () => useGet({ url: CLIENT_CONFIG }));

  const isHideHeader = React.useMemo(() => {
    if (clientConfigData) {
      return clientConfigData?.clientConfigs
        ?.filter((item) => item.name === "hide_header")
        .map((i) => i.value);
    }
  }, [clientConfigData]);

  const isSSOCustom = React.useMemo(() => {
    if (clientConfigData) {
      return clientConfigData?.clientConfigs
        ?.filter((item) => item.name === "sso_type")
        .map((i) => i.value)[0];
    }
  }, [clientConfigData]);

  React.useEffect(() => {
    localStorage.setItem("sso_type", isSSOCustom);
  }, [isSSOCustom]);

  React.useEffect(() => {
    if (isHideHeader) {
      localStorage.setItem("isHideHeader", isHideHeader[0]);
    }
  }, [isHideHeader]);

  React.useEffect(() => {
    if (fetchedClientConfigData && clientConfigData) {
      context.dispatch({
        type: CLIENT_CONFIG_DETAILS,
        payload: { ...context.state, clientConfigData: clientConfigData },
      });
    }
  }, [fetchedClientConfigData, clientConfigData]);

  React.useEffect(() => {
    //themeName: dark OR light
    if (Themes['light']) {
      localStorage.setItem("theme", "light");
      for (var key in Themes['light']) {
        if (
          context?.state?.clientConfigData &&
          Themes[themeName].hasOwnProperty(key)
        ) {
          // colorCode acc to theme key value
          const colorCode = context?.state?.clientConfigData?.clientConfigs
            .filter((data) => data.name === key)
            .map((val) => val.value);
          // based on colorCode findout Theme Object
          const themeValue =
            colorCode !== undefined
              ? colorCode.toString()
              : Themes[themeName][key];
          document.documentElement.style.setProperty(key, themeValue);
        }
      }
    }
  }, [Themes, themeName, context?.state?.clientConfigData]);

  return (
    <>
      <React.Suspense fallback={<Loader loaderMessage="Loading..." />}>
        <Switch>
          {route?.routes.map((route, index) => (
            <RouteWithSubRoutes key={index} {...route} />
          ))}
        </Switch>
      </React.Suspense>
    </>
  );
}
